import "./NursingCaregiverInCityImmediateSolutionWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import HeroTreppenhausReinigung from "./sections/HeroTreppenhausReinigung";
import OurServices from "./sections/OurServices";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function NursingCaregiverInCityImmediateSolutionWithinHoursPage() {
  return <div>
      <Header />
      <HeroTreppenhausReinigung />
      <OurServices />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}